import { ReactElement } from 'react';

import DashboardVariantV2CarrierContentInTransitTabProvider, {
  useDashboardVariantV2CarrierContentInTransitTabContext,
} from './Context';

import {
  DashboardVariantV2CarrierContentTabContainer,
  DashboardVariantV2CarrierContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2CarrierContentInTransitTabActions,
  DashboardVariantV2CarrierContentInTransitTabCurrenFilters,
  DashboardVariantV2CarrierContentInTransitTabDataTable,
  DashboardVariantV2CarrierContentInTransitTabTracking,
} from './Components';

const DashboardVariantV2CarrierContentInTransitTab = (): ReactElement => {
  const {
    showTracking: { value: showTracking },
  } = useDashboardVariantV2CarrierContentInTransitTabContext();
  return (
    <DashboardVariantV2CarrierContentTabContainer>
      <DashboardVariantV2CarrierContentInTransitTabActions />

      {!showTracking && (
        <DashboardVariantV2CarrierContentInTransitTabCurrenFilters />
      )}

      <DashboardVariantV2CarrierContentWrapper>
        {!showTracking && (
          <DashboardVariantV2CarrierContentInTransitTabDataTable />
        )}

        {showTracking && (
          <DashboardVariantV2CarrierContentInTransitTabTracking />
        )}
      </DashboardVariantV2CarrierContentWrapper>
    </DashboardVariantV2CarrierContentTabContainer>
  );
};

const DashboardVariantV2CarrierContentInTransitTabWrapper =
  (): ReactElement => (
    <DashboardVariantV2CarrierContentInTransitTabProvider>
      <DashboardVariantV2CarrierContentInTransitTab />
    </DashboardVariantV2CarrierContentInTransitTabProvider>
  );

export default DashboardVariantV2CarrierContentInTransitTabWrapper;
